import React from 'react';
import { RailsThumbnailItem } from '~/typings/services/rails/item';
import { RailsPaging } from '~/typings/services/rails/paging';

export const BrowseItemsContext = React.createContext<{
  items: RailsThumbnailItem[];
  paging: RailsPaging;
}>({
  items: [],
  paging: {
    page: 1,
    page_size: 24,
    total_count: 0,
    total_pages: 1,
    has_next_page: false,
    total_count_truncated: false,
  },
});
